interface ICaretRightFillIconProps {
  /**
   * Icon class name
   */
  className?: string;
}

/**
 * -----------------------------------------------------------------------------
 * It renders a caret right filled icon
 */
export function CaretRightFillIcon({
  className,
}: Readonly<ICaretRightFillIconProps>) {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      viewBox="0 0 14 24"
    >
      <path
        className="fill-gray-950 dark:fill-gray-50"
        d="M10.869 9.381 2.119.631a.875.875 0 0 0-1.494.619v17.5a.875.875 0 0 0 1.494.619l8.75-8.75a.875.875 0 0 0 0-1.238Z"
      />
    </svg>
  );
}
